<template>  
    <div>
        <b-card no-body>
            <b-card-header>
                <div class="float-left">
                    <span class="h5">Novo Boletim de Medição</span>
                </div>
                <div class="float-right">
                    <button class="btn btn-danger" @click.stop="voltar()">
                        <i class="fa fa-arrow-left mr-2"></i>Voltar para lista de boletins
                    </button>
                </div>
            </b-card-header>
            <b-card-body>
                <boletim-medicao-form 
                    :contrato="contrato" 
                    :valor-total-boletins="valorTotalBoletins"
                    @recarregarListaBoletinsMedicao="recarregarListaBoletinsMedicao" 
                />
            </b-card-body>
        </b-card>
    </div>
</template>

<script>

import BoletimMedicaoForm from './componentes/BoletimMedicaoForm.vue';

export default {

    components: {
        BoletimMedicaoForm
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },
        valorTotalBoletins: {
            type: Number,
            default: 0
        },
    },

    data() {
        return {
            
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'FornecedorContratos_BoletinsMedicoes' })
        },

        recarregarListaBoletinsMedicao() {
            this.$emit('recarregarListaBoletinsMedicao')
            this.$router.push({ name: 'FornecedorContratos_BoletinsMedicoes' })
        }
    }
}
</script>